import { useCallback } from 'react';
import styled from 'styled-components';
import { Checkbox } from '@clds/checkbox';
import Tooltip from '@clds/tooltip';
import { InlineFieldLayout, Label, GroupLayoutWrapper } from '@clds/form';
import t from 'common/i18n';
import { useFilterParams } from '../../../common/selectors';
import { LastSectionBox } from '../../../common/components/FiltersPanel/Filters.styles';

export const CustomInlineFieldLayout = styled(InlineFieldLayout)`
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
`;

export default ({ handleSearch, source }) => {
  const { excludeNudity, excludeEditorialUseOnly, embedContentOnly, licenseType } = useFilterParams(source);
  const licenseNotCreative = licenseType !== 'creative';

  const excludeNudityChange = useCallback(
    (item) => {
      handleSearch({
        filters: {
          excludeNudity: !excludeNudity,
        },
      });
    },
    [handleSearch, excludeNudity]
  );

  const excludeEditorialUseOnlyChange = useCallback(
    (item) => {
      if (licenseType === 'creative') {
        handleSearch({
          filters: {
            excludeEditorialUseOnly: !excludeEditorialUseOnly,
          },
        });
      }
    },
    [excludeEditorialUseOnly, handleSearch, licenseType]
  );
  const embedContentOnlyChange = useCallback(
    (item) => {
      if (licenseType === 'creative') {
        handleSearch({
          filters: {
            embedContentOnly: !embedContentOnly,
          },
        });
      }
    },
    [embedContentOnly, handleSearch, licenseType]
  );

  return (
    <LastSectionBox data-test="more-section">
      <label>{t(`${source}.filters.more.label`)}</label>
      <GroupLayoutWrapper>
        <Tooltip trigger="hover" title={licenseNotCreative ? t(`${source}.filters.available_for_creative_images`) : null} placement="bottom">
          <CustomInlineFieldLayout
            disabled={licenseNotCreative}
            label={<Label htmlFor="exclude_editorial_use_only">{t(`${source}.filters.more.exclude_editorial_use_only`)}</Label>}
          >
            <Checkbox id="exclude_editorial_use_only" value={!licenseNotCreative && excludeEditorialUseOnly} onClick={excludeEditorialUseOnlyChange} />
          </CustomInlineFieldLayout>
        </Tooltip>
        <Tooltip trigger="hover" title={licenseNotCreative ? t(`${source}.filters.available_for_creative_images`) : null} placement="bottom">
          <CustomInlineFieldLayout
            disabled={licenseNotCreative}
            label={<Label htmlFor="embed_content_only">{t(`${source}.filters.more.embed_content_only`)}</Label>}
          >
            <Checkbox id="embed_content_only" value={!licenseNotCreative && embedContentOnly} onClick={embedContentOnlyChange} />
          </CustomInlineFieldLayout>
        </Tooltip>
        <CustomInlineFieldLayout label={<Label htmlFor="safe">{t(`${source}.filters.more.safe`)}</Label>}>
          <Checkbox id="safe" value={excludeNudity} onClick={excludeNudityChange} />
        </CustomInlineFieldLayout>
      </GroupLayoutWrapper>
    </LastSectionBox>
  );
};
